import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { ExplorerTableInfo, ExplorerTableData } from "@shared/types";

export function useExplorerTables() {
  return useQuery({
    queryKey: ["explorer", "tables"],
    queryFn: () => apiFetch<ExplorerTableInfo[]>("/api/explorer/tables"),
    staleTime: 10 * 60 * 1000,
  });
}

export function useExplorerData(
  slug: string | null,
  page: number,
  limit: number,
  search: string,
  sort: string,
  order: "asc" | "desc"
) {
  return useQuery({
    queryKey: ["explorer", "data", slug, page, limit, search, sort, order],
    queryFn: () =>
      apiFetch<ExplorerTableData>(`/api/explorer/data/${slug}`, {
        page,
        limit,
        search: search || undefined,
        sort: sort || undefined,
        order,
      }),
    enabled: !!slug,
    placeholderData: keepPreviousData,
  });
}
